import { render, staticRenderFns } from "./FeaturedBanner.vue?vue&type=template&id=29ff7a22&scoped=true&"
import script from "./FeaturedBanner.vue?vue&type=script&lang=js&"
export * from "./FeaturedBanner.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedBanner.vue?vue&type=style&index=0&id=29ff7a22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ff7a22",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconCircleArrowLeft: require('/opt/build/repo/components/icons/IconCircleArrowLeft.vue').default,IconCircleArrowRight: require('/opt/build/repo/components/icons/IconCircleArrowRight.vue').default})
